import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=cf86bc4e&scoped=true"
import script from "./ContactInfo.vue?vue&type=script&lang=js"
export * from "./ContactInfo.vue?vue&type=script&lang=js"
import style0 from "./ContactInfo.vue?vue&type=style&index=0&id=cf86bc4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf86bc4e",
  null
  
)

export default component.exports